import React from 'react';
import CriteriaList, { ICriteriaData, IOption } from '../../../../CriteriaList';
import { useMessageManagerProvider } from '../../../../../../../../context/messageManager';
import ModuleEditBlock from '../Block';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../../../../../../../components/Common/UI/Select';
import Checkbox from '../../../../../../../../../components/Common/UI/Checkbox';

const optionsList: IOption[] = [
  { value: 'account', label: 'Account Number' },
  { value: 'zipCode', label: 'Zip Code' },
  { value: 'interestRate', label: 'Interest Rate' },
  { value: 'major', label: 'Major' },
  { value: 'balance', label: 'Balance' },
  { value: 'endBalance', label: 'End Balance' },
  { value: 'productType', label: 'Product Type' },
  { value: 'maturityDays', label: 'Maturity Days' },
  { value: 'accountType', label: 'Account Type' },
  { value: 'totalBalance', label: 'Total Balance' },
];

function CriteriaBlock({ tab }: { tab: number }) {
  const { selectedModule, handleSelectedModule, handleDispatch, state } = useMessageManagerProvider();

  const { endOfStatement } = state.step2;
  const selected = tab === 0 ? selectedModule?.item : endOfStatement.selected;
  const isStatementText = tab === 0 && state.step2.statement.mode === 'text';
  const requireCriteriaId = `requireCriteria-${tab}`;

  const handleAddCriteria = () => {
    if (!selected?.id) return;

    const newCriteria: ICriteriaData = {
      id: crypto.randomUUID(),
      is: true,
      type: 'accountType',
      input: '',
    };

    if (tab === 0 && selectedModule?.item?.id) {
      if (isStatementText) {
        handleSelectedModule({
          ...selectedModule,
          item: {
            ...selected,
            textCriteria: selected.textCriteria[selectedModule.textTabIndex || 0]
              ? selected.textCriteria.map((el, index) =>
                  index === selectedModule.textTabIndex ? [...el, newCriteria] : el,
                )
              : [...selected.textCriteria, [newCriteria]],
          },
        });

        return;
      }

      handleSelectedModule({
        ...selectedModule,
        item: {
          ...selected,
          criteria: selected.criteria ? [...selected.criteria, newCriteria] : [newCriteria],
        },
      });
    }

    if (tab === 1) {
      handleDispatch({
        step2: {
          ...state.step2,
          endOfStatement: {
            ...endOfStatement,
            selected: {
              ...selected,
              criteria: selected.criteria ? [...selected.criteria, newCriteria] : [newCriteria],
            },
          },
        },
      });
    }
  };

  const handleChangeCriteria = ({ key, value }: Record<string, string>, id: string) => {
    if (!selected) return;

    const newData = isStatementText
      ? selected.textCriteria[selectedModule?.textTabIndex || 0].map(el =>
          el.id === id ? { ...el, [key]: value } : el,
        )
      : selected.criteria.map(el => (el.id === id ? { ...el, [key]: value } : el));

    if (tab === 0 && selectedModule?.item?.id) {
      if (isStatementText) {
        handleSelectedModule({
          ...selectedModule,
          item: {
            ...selectedModule.item,
            textCriteria: selectedModule.item.textCriteria.map((el, index) =>
              index === selectedModule?.textTabIndex ? newData : el,
            ),
          },
        });

        return;
      }

      handleSelectedModule({
        ...selectedModule,
        item: { ...selectedModule.item, criteria: newData },
      });
    }

    if (tab === 1) {
      handleDispatch({
        step2: {
          ...state.step2,
          endOfStatement: { ...endOfStatement, selected: { ...selected, criteria: newData } },
        },
      });
    }
  };

  const handleRemoveCriteria = (id: string) => {
    if (!selected) return;

    const newData = isStatementText
      ? selected.textCriteria[selectedModule?.textTabIndex || 0].filter(el => el.id !== id)
      : selected.criteria.filter(el => el.id !== id);

    if (tab === 0 && selectedModule?.item?.id) {
      if (isStatementText) {
        handleSelectedModule({
          ...selectedModule,
          item: {
            ...selectedModule.item,
            textCriteria: selectedModule.item.textCriteria.map((el, index) =>
              index === selectedModule.textTabIndex ? newData : el,
            ),
          },
        });

        return;
      }

      handleSelectedModule({
        ...selectedModule,
        item: { ...selectedModule.item, criteria: newData },
      });
    }

    if (tab === 1) {
      handleDispatch({
        step2: {
          ...state.step2,
          endOfStatement: { ...endOfStatement, selected: { ...selected, criteria: newData } },
        },
      });
    }
  };

  return (
    <ModuleEditBlock title="Criteria" subTitle="These criteria will be applied to the selected module only">
      <div className="flex items-center justify-between gap-[10px] mb-[20px]">
        <Select>
          <SelectTrigger className="w-auto">
            <SelectValue placeholder="Load Saved Templates" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="zero">Load Saved Templates</SelectItem>
            <SelectItem value="one">Promo Campaign</SelectItem>
            <SelectItem value="two">Campaign 2</SelectItem>
          </SelectContent>
        </Select>
        <div className="flex gap-2 items-center opacity-70">
          <Checkbox id={requireCriteriaId} />
          <label htmlFor={requireCriteriaId} className="text-sm text-primary cursor-pointer">
            <strong>Require all criteria</strong>
          </label>
        </div>
      </div>
      <CriteriaList
        options={optionsList}
        data={
          isStatementText ? selected?.textCriteria[selectedModule?.textTabIndex || 0] || [] : selected?.criteria || []
        }
        opposite
        handleRemove={handleRemoveCriteria}
        handleAdd={handleAddCriteria}
        onChange={handleChangeCriteria}
      />
    </ModuleEditBlock>
  );
}

export default CriteriaBlock;
